import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, MenuItem, styled, Typography } from '@mui/material';

export const MenuItemContainer = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'isSubMenuOpen',
})(({ theme, isSubMenuOpen }) => ({
  width: '100%',
  height: '40px',
  minHeight: '40px',
  paddingTop: 0,
  paddingBottom: 0,
  justifyContent: 'center',
  paddingRight: 0,
  paddingLeft: 0,
  borderBottom: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,

  '& .MuiTouchRipple-root': {
    display: 'none',
  },

  ...(isSubMenuOpen && {
    '& .MuiTypography-root': {
      color: theme.palette.colors.mainFocused,
    },
  }),

  '&:active': {
    '& .MuiTypography-root': {
      color: theme.palette.colors.mainFocused,
    },
  },
}));

export const MenuItemInnerContainer = styled(Box)(({ theme }) => ({
  width: '328px',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',

  [theme.breakpoints.up('sm')]: {
    width: '468px',
  },
  [theme.breakpoints.up('md')]: {
    width: '620px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '944px',
  },
  [theme.breakpoints.up('xxl')]: {
    width: '1304px',
  },
  [theme.breakpoints.up('xxxxl')]: {
    width: '1456px',
  },
}));

export const ItemDescr = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
}));

export const ItemIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.colors.mainFocused,
}));

export const ItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textTransform: 'uppercase',
}));

export const ArrowIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '12px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  width: 'auto',
  position: 'absolute',
  right: 0,
}));
